import type { ScheduleActivity, ScheduleExternalActivity } from '../types'

export interface LinkEndpoint { label: string; foreign: boolean; scheduleId: string }

/** A dependency endpoint's display label (spec B §9.7): local peers are `rowNumber name`, sourced
 * from `Tree.rowNumberById` — the same map the grid uses for its own row numbers; foreign peers are
 * `scheduleName › name`. Shared by the activity panel's `DependenciesSection` and the timeline's
 * link-delete confirmation (Task 18) so both describe an endpoint identically. */
export const linkEndpointLabel = (
  byId: Map<string, ScheduleActivity>,
  externalById: Map<string, ScheduleExternalActivity>,
  rowNumberById: Map<string, number>,
  id: string,
): LinkEndpoint => {
  const a = byId.get(id)
  if (a) return { label: `${rowNumberById.get(id) ?? a.wbsCode} ${a.name}`, foreign: false, scheduleId: a.scheduleId }
  const e = externalById.get(id)
  return { label: e ? `${e.scheduleName} › ${e.name}` : id, foreign: true, scheduleId: e ? e.scheduleId : '' }
}
